module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAACCAYAAABPJGxCAAAAGElEQVQImWNkWPDyP8MAAKaBsJSBgYEBAF+NAoxEWFTEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/support/矩形2.png
// module id = RD3A
// module chunks = 1